import { render, staticRenderFns } from "./AllocationTable.vue?vue&type=template&id=48706a2d&lang=pug"
import script from "./AllocationTable.vue?vue&type=script&lang=js"
export * from "./AllocationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports